import React, { useEffect, useState } from 'react';
import './ToggleSwitch.css';

function ToggleSwitch({ handleSwitch, isDeliveryFlag, enableHomeDel = true, enablePickupDel = true }) {
  const [isDelivery, setIsDelivery] = useState(isDeliveryFlag);

  const isHomeDelEnabled = enableHomeDel === true || enableHomeDel === "true" || enableHomeDel === 1;
  const isPickupEnabled = enablePickupDel === true || enablePickupDel === "true" || enablePickupDel === 1;

  useEffect(() => {
    setIsDelivery(isDeliveryFlag);
  }, [isDeliveryFlag]);

  const handleToggle = (flag) => {
    if (flag && !isHomeDelEnabled) return;
    if (!flag && !isPickupEnabled) return;

    setIsDelivery(flag);
    handleSwitch(flag);
  };

  return (
    <div className="toggle-container">
      <div className="toggle-switch">
        <div
          className={`toggle-option ${isDelivery ? 'active' : ''} ${!isHomeDelEnabled ? 'disabled' : ''}`}
          onClick={() => handleToggle(true)}
          style={!isHomeDelEnabled ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}
        >
          Delivery
        </div>
        <div
          className={`toggle-option ${!isDelivery ? 'active' : ''} ${!isPickupEnabled ? 'disabled' : ''}`}
          onClick={() => handleToggle(false)}
          style={!isPickupEnabled ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}
        >
          Pick up
        </div>
        <div className={`toggle-slider ${isDelivery ? '' : 'right'}`}></div>
      </div>
    </div>
  );
}

export default ToggleSwitch;
